import { ReactNode } from 'react';

import { LucideProps } from 'lucide-react';
import { PaymentType } from 'pages/Job/context';

export interface PaymentPoint {
  icon: ReactNode;
  text: string;
}

export const ICON_PROPS: LucideProps = {
  size: 16,
  className: 'mb-auto stroke-purple-300 min-w-4 mt-0.5',
  stroke: '',
};

export const TITLES: Record<PaymentType, string> = {
  FINANCE: 'Pay with finance',
  OPEN_BANKING: 'Pay in full',
};
